<template>
  <!-- 类目属性 -->
  <div class="Minister-top information">
    <div class="Minister-top-top Ministerbackground">
      <div class="Minister-top-left Minister-top-color">类目属性</div>
    </div>
    <div class="information_content">
      <div class="information_input" v-for="attr in list" :key="attr.id">
        <div class="information_Title">
          <span v-if="attr.isMandatory" style="color: red">*</span>
          <span>{{ attr.displayAttributeName }}</span>
          <el-tooltip
            v-if="attr.introduction"
            effect="dark"
            :content="attr.introduction"
            placement="bottom">
            <img :src="urlQueImg" style="width: 14px; height: 14px" alt="" />
          </el-tooltip>
        </div>
        <div class="input_el">
          <template v-if="attr.inputType === 'TEXT_FILED'">
            <el-input
              type="text"
              class="width67"
              placeholder="请输入"
              v-model="formData[attr.originalAttributeName]">
              <el-select
                v-if="attr.attributeUnits.length"
                slot="append"
                v-model="formData[attr.originalAttributeName + 'unit']"
                placeholder="请选择"
                style="width: 100px">
                <el-option
                  v-for="item in attr.attributeUnits"
                  :key="item"
                  :label="item"
                  :value="item"></el-option>
              </el-select>
            </el-input>
          </template>
          <template v-else-if="attr.inputType === 'DROP_DOWN'">
            <el-select
              v-model="formData[attr.originalAttributeName]"
              class="width67"
              value-key="id"
              placeholder="请选择">
              <el-option
                v-for="item in attr.shopeeCategoryAttributeValues"
                :key="item.id"
                :label="item.displayValueName"
                :value="item"></el-option>
            </el-select>
          </template>
          <template v-else-if="attr.inputType === 'MULTIPLE_SELECT'">
            <el-select
              v-model="formData[attr.originalAttributeName]"
              class="width67"
              multiple
              value-key="id"
              placeholder="请选择">
              <el-option
                v-for="item in attr.shopeeCategoryAttributeValues"
                :key="item.id"
                :label="item.displayValueName"
                :value="item"></el-option>
            </el-select>
          </template>
          <template v-else-if="attr.inputType === 'COMBO_BOX'">
            <el-select
              v-model="formData[attr.originalAttributeName]"
              class="width67"
              value-key="id"
              filterable
              allow-create
              default-first-option
              placeholder="请选择">
              <el-option
                v-for="item in attr.shopeeCategoryAttributeValues"
                :key="item.id"
                :label="item.displayValueName"
                :value="item"></el-option>
            </el-select>
          </template>
          <template v-else-if="attr.inputType === 'MULTIPLE_SELECT_COMBO_BOX'">
            <el-select
              v-model="formData[attr.originalAttributeName]"
              class="width67"
              multiple
              filterable
              allow-create
              default-first-option
              value-key="id"
              placeholder="请选择">
              <el-option
                v-for="item in attr.shopeeCategoryAttributeValues"
                :key="item.id"
                :label="item.displayValueName"
                :value="item"></el-option>
            </el-select>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * TEXT_FILED 输入框
 * DROP_DOWN 下拉单选
 * MULTIPLE_SELECT 下拉多选
 * COMBO_BOX 下拉单选可自定义
 * MULTIPLE_SELECT_COMBO_BOX 下拉多选可自定义
 */
export default {
  name: 'laiyuanComp',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      //问号图标的地址
      urlQueImg: require('@/assets/images/wenhao.png'),
      formData: {},
      editList: null
    }
  },
  watch: {
    list(val) {
      val.forEach((attr) => {
        const key = attr.originalAttributeName
        this.$set(this.formData, key, '')
        if (attr.attributeUnits.length) {
          this.$set(this.formData, key + 'unit', '')
        }

        if (this.editList) {
          const attrItem = this.editList.find(
            (item) => item.attribute_id === attr.attributeId
          )
          if (attrItem) {
            let val
            attrItem.attribute_value_list.forEach((v) => {
              if (attr.inputType === 'TEXT_FILED') {
                val = v.original_value_name
              } else if (['DROP_DOWN', 'COMBO_BOX'].includes(attr.inputType)) {
                val = attr.shopeeCategoryAttributeValues.find(
                  (av) => av.valueId === v.value_id
                )
                val = val || v.original_value_name
              } else if (
                ['MULTIPLE_SELECT', 'MULTIPLE_SELECT_COMBO_BOX'].includes(
                  attr.inputType
                )
              ) {
                let temporary = attr.shopeeCategoryAttributeValues.find(
                  (av) => av.valueId === v.value_id
                )
                val = []
                temporary
                  ? val.push(temporary)
                  : val.push(v.original_value_name)
              }
            })

            this.$set(this.formData, key, val)
          }
        }
      })
    }
  },
  created() {},
  methods: {
    getFormData() {
      return JSON.parse(JSON.stringify(this.formData))
    },
    setFormData(data) {
      this.editList = data
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../shopee.less';
.information_input {
  margin: 0 auto 10px;
  display: flex;
  justify-content: center;
  .input_el {
    flex: 1;
  }
  .information_Title {
    width: 30% !important;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
